






import { Component, Prop, Mixins } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';
import { PartAvailability } from '../../entities/PartAvailability';
import { localize } from '../../filters/localize';
import { PartDeliveryTimeInformation } from '../../entities/PartDeliveryTimeInformation';

@Component
export default class DeliveryTimeToolTip extends Mixins(BaseMixin) {
    @Prop({ required: true })
    private partAvailability!: PartAvailability;

    private toolTipMessage(): string {
        let returnValue = `<div class="delivery-time-tooltip__tooltip-innertext">
            <span>${localize(
                this.l10n.DELIVERY_TIME_TOOLTIP.HEADER_TEXT
            )}</span></div>`;
        this.partAvailability.partDeliveryTimeInformations.forEach(
            (element: PartDeliveryTimeInformation) => {
                returnValue += `<div class="delivery-time-tooltip__tooltip-innertext">
                <span>${element.deliveryTimeInformationText} </span>
                <span>${element.quantity} ${localize(
                    this.l10n.DELIVERY_TIME_TOOLTIP.EACH_TEXT
                )}</span>
            </div>`;
            }
        );

        returnValue += `<div class="delivery-time-tooltip__tooltip-innertext"
            ><span>${this.partAvailability.infoText}</span>
        </div>`;
        return returnValue;
    }
}
